import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true;
  }

  // Store the attempted URL for redirecting after login
  const returnUrl = state.url;
  console.log('🔒 Auth Guard: Redirecting to login. Return URL:', returnUrl);
  
  // Navigate to login with return URL
  router.navigate(['/login'], { 
    queryParams: { returnUrl: returnUrl } 
  });
  return false;
};
